export default __webpack_public_path__ + "static/media/rishabh-profile.2b6cf8af.jpg";